import type { ReactElement, ReactNode } from 'react';

import { StatusChip, TechnicalDetails } from './admin-ui';

export function ContractorShell(props: {
  readonly statusLabel?: string;
  readonly statusTone?: string;
  readonly children: ReactNode;
}): ReactElement {
  return (
    <div className="contractor-portal">
      <header className="contractor-header">
        <div className="contractor-brand-block">
          <p className="contractor-brand">Допуск ТС</p>
          <p className="contractor-brand-secondary">GIRYA / CheckTS</p>
        </div>
        {props.statusLabel !== undefined ? (
          <StatusChip label={props.statusLabel} tone={props.statusTone} />
        ) : null}
      </header>
      {props.children}
    </div>
  );
}

export function ContractorIntro(props: {
  readonly eyebrow: string;
  readonly title: string;
  readonly lead: string;
}): ReactElement {
  return (
    <section className="contractor-intro" aria-labelledby="contractor-intro-title">
      <p className="contractor-eyebrow">{props.eyebrow}</p>
      <h1 id="contractor-intro-title">{props.title}</h1>
      <p className="contractor-lead">{props.lead}</p>
    </section>
  );
}

export function ContractorCard(props: {
  readonly title: string;
  readonly titleId: string;
  readonly description?: string;
  readonly children: ReactNode;
}): ReactElement {
  return (
    <section className="contractor-card" aria-labelledby={props.titleId}>
      <h2 id={props.titleId} className="questionnaire-section-title">
        {props.title}
      </h2>
      {props.description !== undefined ? (
        <p className="contractor-card-desc">{props.description}</p>
      ) : null}
      {props.children}
    </section>
  );
}

export function ContractorTechnicalBlock(props: { readonly children: ReactNode }): ReactElement {
  return (
    <TechnicalDetails>
      <div className="contractor-tech">{props.children}</div>
    </TechnicalDetails>
  );
}
